import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { InventoryOutputDetailModel } from 'src/app/models/inventory/inventory-output-detail.model';
import { InventoryOutputModel } from 'src/app/models/inventory/inventory-output.model';
import { RentalStockModel } from 'src/app/models/rental/rental-stock-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { StoreService } from 'src/app/services/archive/store.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { SubrentalOutputDetailService } from 'src/app/services/subrental/subrental-output-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-subrental-output-detail',
  templateUrl: './register-subrental-output-detail.component.html',
  styleUrls: ['./register-subrental-output-detail.component.scss'],
  standalone: false
})
export class RegisterSubrentalOutputDetailComponent implements OnInit, OnDestroy {
  @ViewChild('articleSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;

  @Input() disabled: boolean = false;
  @Input('subrentalOutputContract')
  set changeSubrental(changeSubrental: InventoryOutputModel) {
    this.changeSubrentalOutput(changeSubrental);
  }
  @Input('subrentalOutputDetailContract')
  set changeSubrentalDetail(changeSubrentalDetail: InventoryOutputDetailModel) {
    this.changeSubrentalOutputDetail(changeSubrentalDetail);
  }
  @Output() isFormView = new EventEmitter<boolean>();
  @Output() updateListDetail = new EventEmitter<boolean>();

  articleId: number = 0;
  ascendantArticle: boolean = true;
  codeNameArticle: string = '';
  columnSortArticle: string | null = null;
  dataArticle: PagedResponseModel<any> = new PagedResponseModel<any>();
  filtersArticle: ColumnResponseModel[] = []
  formSubrentalOutputDetail: FormGroup = new FormGroup({});
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
    actions: []
  })
  subrentalOutputDetailId: number = 0;
  subrentalOutputContract: InventoryOutputModel = new InventoryOutputModel();
  subrentalOutputDetailContract: InventoryOutputDetailModel = new InventoryOutputDetailModel();
  limitArticle: number = 5;
  listArticles: any[] = [];
  listStores: any[] = [];
  output$ = new Subject<any>();
  pageArticle: number = 1;
  storeId: number = 0;
  subscription: Subscription;
  componentTableSelection = CustomTableSelectComponent;

  constructor(private articleService: ArticleService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private subrentalOutputDetailService: SubrentalOutputDetailService,
    private storeService: StoreService,
    private toastHandlerService: ToastHandlerService) {
    this.validateForm(new InventoryOutputDetailModel);
  }

  ngOnInit() {
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  async changeSubrentalOutput(changeSubrental: InventoryOutputModel) {
    if (changeSubrental.branchId != this.subrentalOutputContract.branchId) {
      await this.getListStoresForSelect(changeSubrental.branchId, changeSubrental.inventoryId);
    }
    if (changeSubrental.inventoryOutputId != 0) {
      this.subrentalOutputContract = changeSubrental;
    }
  }

  async changeSubrentalOutputDetail(changeSubrentalDetail: InventoryOutputDetailModel) {
    this.subrentalOutputDetailContract = changeSubrentalDetail;
    this.storeId = 0;
    this.articleId = 0;
    this.codeNameArticle = "";

    this.validateForm(changeSubrentalDetail);

    if (changeSubrentalDetail.inventoryOutputDetailId !== 0) {
      this.subrentalOutputDetailId = changeSubrentalDetail.inventoryOutputDetailId;
      await Promise.all([
        this.getStore(changeSubrentalDetail.storeId, false),
        this.getArticle(changeSubrentalDetail.articleId, false)
      ]);
      await this.getStocksByArticleIdStoreId();
    }
  }

  clearForm() {
    this.storeId = 0;
    this.articleId = 0;
    this.codeNameArticle = "";
    const modelSubrentalOutputDetail = new InventoryOutputDetailModel;
    this.validateForm(modelSubrentalOutputDetail)
    this.isFormView.emit(false);
  }

  async getArticle(articleId: number | null, reload: boolean) {
    let validArticle = null;
    let codeNameArticle = "";
    if (articleId != null) {
      const article = await firstValueFrom(this.articleService.getArticleById(articleId));
      if (article) {
        validArticle = articleId;
        codeNameArticle = `${article.code} - ${article.name}`;
      }
    }

    this.articleId = validArticle ?? 0;
    this.codeNameArticle = codeNameArticle;
    this.formSubrentalOutputDetail.controls["articleId"].patchValue(validArticle);
    if (reload) {
      await this.getSubrentalOutputDetailByKeys();
    }
  }

  async getArticlesForOutput() {
    try {
      this.dataArticle = await firstValueFrom(this.subrentalOutputDetailService.getListStocksInShop(this.subrentalOutputContract.inventoryOutputId, this.storeId, this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle));
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getColumnsArticle() {
    try {

      this.headerArticle = await firstValueFrom(this.subrentalOutputDetailService.getColumnsForArticles());
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }

  async getListStoresForSelect(branchId: number, inventoryId: number) {
    try {
      this.listStores = await firstValueFrom(this.storeService.getStoresActivesByBranchInventoryForSelect(branchId, inventoryId));
    } catch (error) {
      console.error('Error al obtener la lista de bodegas.', error);
    }
  }

  async getStocksByArticleIdStoreId() {
    if (this.storeId != 0 && this.articleId != 0) {
      const rentalStockModel = new RentalStockModel();
      rentalStockModel.articleId = this.articleId;
      rentalStockModel.storeId = this.storeId;
      rentalStockModel.dateMovement = this.subrentalOutputContract.dateOutput;

      const stock = await firstValueFrom(this.subrentalOutputDetailService.getStocksByArticleIdStoreId(rentalStockModel));
      this.formSubrentalOutputDetail.controls["stock"].patchValue(stock);
    }
  }

  async getStore(storeId: number | null, reload: boolean) {
    this.storeId = storeId ?? 0;
    this.formSubrentalOutputDetail.controls["storeId"].patchValue(storeId);

    if (reload) {
      this.subrentalOutputDetailId = 0;
      this.articleId = 0;
      this.codeNameArticle = "";
      const modelSubrentalOutputDetail = new InventoryOutputDetailModel;
      modelSubrentalOutputDetail.storeId = this.storeId;
      this.validateForm(modelSubrentalOutputDetail)
    }
  }

  async getSubrentalOutputDetailByKeys() {
    if (this.storeId === 0 || this.articleId === 0) return;

    const OutputId = this.subrentalOutputContract.inventoryOutputId;
    const response = await firstValueFrom(
      this.subrentalOutputDetailService.getSubrentalOutputDetailByKeys(OutputId, this.storeId, this.articleId));
    if (response.inventoryOutputDetailId === 0) {
      this.subrentalOutputDetailContract = new InventoryOutputDetailModel();
      this.subrentalOutputDetailId = 0;
      this.subrentalOutputDetailContract.storeId = this.storeId;
      this.subrentalOutputDetailContract.articleId = this.articleId;

      this.validateForm(this.subrentalOutputDetailContract);
      await this.getStocksByArticleIdStoreId();
      return;
    }

    this.subrentalOutputDetailContract = response;
    this.subrentalOutputDetailId = response.inventoryOutputDetailId;
    this.validateForm(response);
    await Promise.all([
      this.getStore(response.storeId, false),
      this.getArticle(response.articleId, false)
    ]);

    await this.getStocksByArticleIdStoreId();
  }

  async handleSelectedItem(selectedItem: any) {
    const articleId = parseInt(selectedItem[0]?.articleId);
    this.getArticle(articleId, true)
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    this.getArticlesForOutput();
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async openArticleSelectionModal() {
    if (this.storeId === 0) {
      this.toastHandlerService.showToast('warning', 'Debe seleccionar una bodega.', 'Atención');
      return;
    }

    this.filtersArticle = [];
    await Promise.all([
      this.getColumnsArticle(),
      this.getArticlesForOutput()]
    );
    this.updateInputs();
    this.articleSelectionModalComponent && this.articleSelectionModalComponent.show();
  }

  async send(): Promise<any> {
    if (this.formSubrentalOutputDetail.valid) {

      const modelSubrentalOutputDetail = this.setForm();
      if (modelSubrentalOutputDetail.totalValue < 0) {
        this.toastHandlerService.showToast('warning', 'El valor total no puede ser negativo.', 'Atención');
        return;
      }

      try {
        if (this.subrentalOutputDetailId == 0) {
          await firstValueFrom(this.subrentalOutputDetailService.createSubrentalOutputDetail(modelSubrentalOutputDetail));
          this.toastHandlerService.showToast('success', 'El detalle fue creado exitosamente.', '');
        }
        else {
          await firstValueFrom(this.subrentalOutputDetailService.updateSubrentalOutputDetail(modelSubrentalOutputDetail));
          this.toastHandlerService.showToast('success', 'El detalle fue modficado exitosamente.', '');
        }

        this.subrentalOutputDetailContract = new InventoryOutputDetailModel();
        this.clearForm();
        this.isFormView.emit(true);
        this.updateListDetail.emit(true);
      } catch (error) {
        console.error('Error al guardar el detalle.', error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  setForm(): any {
    this.subrentalOutputDetailContract.storeId = this.formSubrentalOutputDetail.get("storeId")?.value;
    this.subrentalOutputDetailContract.articleId = this.formSubrentalOutputDetail.get("articleId")?.value;
    this.subrentalOutputDetailContract.quantity = this.formSubrentalOutputDetail.get("quantity")?.value;
    this.subrentalOutputDetailContract.inventoryOutputId = this.subrentalOutputContract.inventoryOutputId;

    return this.subrentalOutputDetailContract;
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      storeId: {
        required: 'El campo bodega es obligatorio.'
      },
      articleId: {
        required: 'El campo artículo es obligatorio.'
      },
      quantity: {
        required: 'El campo cantidad es obligatorio.',
        min: 'La cantidad mínima es 1.'
      },
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formSubrentalOutputDetail.get(controlName);

      if (control && control.invalid && control.errors) {
        const errors = control.errors;

        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
  }

  validateForm(subrentalOutputDetail: InventoryOutputDetailModel) {
    this.formSubrentalOutputDetail = this.formBuilder.group({
      storeId: [subrentalOutputDetail.storeId, [Validators.required, Validators.min(1)]],
      articleId: [subrentalOutputDetail.articleId, [Validators.required, Validators.min(1)]],
      stock: [0, []],
      quantity: [subrentalOutputDetail.quantity, [Validators.required, Validators.min(1)]]
    });

    this.formControlStateService.setControlState(this.formSubrentalOutputDetail, ['stock'], false);
  }
}
